export default {
  add_items: 'Lisää tuotteita',
  remove_items: 'Poista tuotteita',
  place_order: 'Tee tilaus',
  pay_now: 'Maksa nyt · {{amount}}',
  go_to_menu: 'Siirry valikkoon',
  secure_checkout: 'Turvallinen kassa...',

  modals: {
    account_switch: {
      title: 'Tili puhelinnumerolla {{phoneNumber}} on jo olemassa',
      description: 'Kirjasimme sinut huolella olemassa olevaan tiliin säilyttäen samalla syöttämäsi tiedot 😊',
      button: 'Jatka',
    },
  },

  error_messages: {
    payment_unsuccessful: {
      title: 'Maksu epäonnistui',
      description: 'Tarkista maksutietosi ja yritä uudelleen.',
    },
    internal_error: {
      title: 'Tilaus epäonnistui 😔',
      description:
        'Valitettavasti tilauksessasi ilmeni odottamaton ongelma, tekninen tiimimme työskentelee jo sen parissa 🛠️.',
    },
    order_blocked: {
      title: 'Tilaus estetty',
      description:
        'Olemme havainneet epäilyttävää toimintaa tililtäsi ja estäneet uudet tilaukset ajankohtaan {{datetime}} asti. Ota yhteyttä tukeen osoitteessa {{supportEmail}} saadaksesi lisätietoja.',
      description_no_datetime:
        'Olemme havainneet epäilyttävää toimintaa tililtäsi ja estäneet uudet tilaukset. Ota yhteyttä tukeen osoitteessa {{supportEmail}} saadaksesi lisätietoja.',
    },
  },

  toasts: {
    input_errors_found: 'Tilaustiedoissasi on joitakin ongelmia',
    select_payment_method: 'Valitse maksutapa tilauksen tekemiseksi.',
  },
};
